exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:1190px){.content{width:100%;height:100%;padding:0}}@media only screen and (min-width:468px) and (max-width:780px){.content{width:100%;height:100%;padding:0;overflow-y:auto;overflow-x:hidden}}@media only screen and (max-width:467px){.content{width:100%;height:100%;padding:0;overflow-y:auto;overflow-x:hidden}}.copyright{margin-top:1%;margin-left:2%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5dc33e5c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard.vue
// module id = 1120
// module chunks = 0